import type {ExtraDeliveryActionContent, ExtraDeliveryStatusConfig} from './types';

export const EXTRA_DELIVERY_ROUTES = {
  list: '/services/promotion-center/extra-delivery/list',
  add: '/services/promotion-center/extra-delivery/add',
  details: '/services/promotion-center/extra-delivery/details/:extraDeliveryId',
  paymentSuccess: '/services/promotion-center/extra-delivery/payment/success'
} as const;

export const EXTRA_DELIVERY_STATUS_CONFIG: Record<string, ExtraDeliveryStatusConfig> = {
  init: {label: 'در انتظار اجرا', color: 'info'},
  active: {label: 'در حال اجرا', color: 'success'},
  paused: {label: 'متوقف شده', color: 'warning'},
  deleted: {label: 'حذف شده', color: 'error'}
};

export const EXTRA_DELIVERY_ACTION_CONTENT: Record<string, ExtraDeliveryActionContent> = {
  init: {
    modalTitle: 'آیا از حذف سرویس محدوده پوشش‌دهی این دوره مطمئن هستید؟',
    modalDescription: 'با حذف، تمامی اطلاعاتی که وارد کردید حذف می‌شود.',
    button: 'بله',
    confirmColor: 'destructive'
  },
  active: {
    modalTitle: 'آیا از توقف سرویس محدوده پوشش‌دهی این دوره مطمئن هستید؟',
    modalDescription: 'با توقف، محدوده پوشش‌دهی در این محدوده‌ها تا زمان ادامه مجدد غیرفعال می‌شود.',
    button: 'بله',
    confirmColor: 'secondary'
  },
  paused: {
    modalTitle: 'آیا می‌خواهید سرویس محدوده پوشش‌دهی را مجدد فعال کنید؟',
    modalDescription: 'با ادامه، محدوده پوشش‌دهی در محدوده‌های انتخاب شده مجدد فعال می‌شود.',
    button: 'بله',
    confirmColor: 'primary'
  }
};

export const EXTRA_DELIVERY_PAGE_SIZE = 10;
